const getAuthHeader = () => {
    return { Authorization: localStorage.getItem('authToken') || '' };
};

export default getAuthHeader;
